import { z } from 'zod';

export const axisSchema = z.object({
  id: z.number(),
  nome: z.string(),
});

export type Axis = z.infer<typeof axisSchema>;

export const dashboardResultsResponseSchema = z.object({
  qtdAlunos: z.number().nullable(),
  qtdRedacoesFeitas: z.number().nullable(),
  qtdRedacoesZeradas: z.number().nullable(),
  notaMedia: z.number().nullable(),
  eixos: z.array(axisSchema).nullish(),
});

export type DashboardResultsResponse = z.infer<typeof dashboardResultsResponseSchema>;
